
import React from 'react';

export const Generalinfo = ({ dtSTD, airportList, crewList }) => {
  const renderCrewMembers = (crewList) => {
    return crewList.map((crewMemberData, index) => {
      const {
        sFirstName = [''],
        sLastName = [''],
        sCrewCat = '',
        nEmpNo = '',
      } = crewMemberData;

      const fname = sFirstName[0]?.toUpperCase() || '';
      const lname = sLastName[0]?.toUpperCase() || '';

    return (
        <div className='crew-member-info' key={index}>
          <p className='crewinfo-crewCat'>{sCrewCat}</p>
          <p className='crewinfo-nEmpNo'>{nEmpNo}</p>
          <p className='crewinfo-sFirstName'>{fname}</p>
          <p className='crewinfo-sLastName'>{lname}</p>
      </div>
    );
    });
  };

  const renderGeneralData = (dtSTD, airportList) => {
    const stdValue = Array.isArray(dtSTD) ? dtSTD[0] : dtSTD;
    const flightDate = stdValue ? stdValue.split('T')[0] : '';

    const departureAirportData =
      airportList?.find(
        (airport) => airport.sAirportFunction[0] === 'DepartureAirport'
      ) || {};

    const arrivalAirportData =
      airportList?.find(
        (airport) => airport.sAirportFunction[0] === 'ArrivalAirport'
      ) || {};

    return (
      <div className='general-flt-info inner-element'>
        <p className='general-date1'>DATE:</p>
        <p className='general-date2'>{flightDate}</p>

        <p className='general-from1'>FROM:</p>
        <p className='general-from12'>
          {departureAirportData.sICAO || ''}/{departureAirportData.sIATA || ''}
        </p>
        <p className='general-from2'>
          {departureAirportData.sAirportName || ''}
        </p>

        <p className='general-to1'>TO:</p>
        <p className='general-to12'>
          {arrivalAirportData.sICAO || ''}/{arrivalAirportData.sIATA || ''}
        </p>
        <p className='general-to2'>{arrivalAirportData.sAirportName || ''}</p>
      </div>
    );
  };

  const crewContent = renderCrewMembers(crewList || []);

  const generalDataContent = renderGeneralData(dtSTD, airportList || []);

    return (
      <div>
      <div className='general-and-crew-container'>
        {generalDataContent}
        <div className='crew-info'>{crewContent}</div>
        </div>
      </div>
    );
};
